import React , {useState} from 'react'
import { useContext } from 'react'
import AuthContext from './AuthContext';
import { useHistory } from "react-router-dom";
import Axios from 'axios';

const FrmNewRegister_th = () => {

  const history = useHistory();
  const {gclang} = useContext(AuthContext);
  
  const [dataregister,setdataregister] = useState({    
    lang:gclang,
    cardid:'',
    name:'',
    lastname:'',
    email:'',  
    questionforsecurity:'',
    answer:'',    
    password:'',        
    repassword:''              
  });

function generateCheckDigit(input12Digits) {
  // check valid card_id
  if (input12Digits.length !== 12 || !/^\d+$/.test(input12Digits)) {
    throw new Error("Input must be a 12-digit numeric string.");
  }

  let total = 0;
  let multiplier = 13;

  // Calculate the weighted sum of the first 12 digits
  for (let i = 0; i < 12; i++) {
    total += parseInt(input12Digits[i], 10) * multiplier;
    multiplier -= 1;
  }

  // Calculate the check digit
  const checkDigit = (11 - (total % 11)) % 10;

  // Append the check digit to the 12-digit input
  return input12Digits + checkDigit.toString();
}

async function btn_update(e) {
  e.preventDefault();
  //let output = generateCheckDigit('310140315876');
  //let chk_output = generateCheckDigit('123456789012');  
  // Extract the first 12 characters
  //const x = '1234567890121';
  //const first12Characters = x.slice(0, 12);
  if(dataregister.name === '' || dataregister.lastname === '' || dataregister.cardid === '' || dataregister.email === '' || dataregister.questionforsecurity === '' || dataregister.repassword === '' || dataregister.answer === '' ){
     alert("please input all data");
     return false;
  }

  if(dataregister.cardid.length >= 13){
    let first12Characters = dataregister.cardid.slice(0,12);
    let chk_output = generateCheckDigit(first12Characters);
    if(chk_output === dataregister.cardid){
      if(dataregister.password === dataregister.repassword)
      {
        const response = await Axios.post("/newregister" , dataregister);
        let output = response.data; 
        //console.log(output);
        //return false;
        if(output[0].issuccess === 1){
          alert(`${output[0].msg}`);          
          history.push('/login');

        }
        else{
          alert(`${output[0].msg}`);
        }
        ////let myoutput = calculateMod10CheckDigit('233101202294468'); // for print barcode
        ////let myoutput = calculateMod10CheckDigit('230000000080344'); // for print barcode
        ////console.log(myoutput);
        
      }
      else{
        alert("โปรดใส่ Password ให้ตรงกับ Repassword");
        return false;
      }
    
    }
    else{
      alert("โปรดใส่บัตรประจำประชาชนให้ถูกต้อง");
      return false;
    }

  }
  else{
    alert("โปรดใส่บัตรประจำประชาชนให้ถูกต้อง");
    return false;
  }
  
}

const handleEditChange = (e,d,index)  =>{
        
  e.preventDefault();
              
  const fieldName = e.target.getAttribute('name');
  const fieldValue = e.target.value;

  const newFormData = {...dataregister }; 
  newFormData[fieldName] = fieldValue;          
  setdataregister(newFormData); 

}

const calculateMod10CheckDigit = (barcode) => {
  // for print barcode cardid
  barcode = barcode.trim();
  const barcodeLength = barcode.length;

  let sumOdd = 0;
  for (let i = 0; i < barcodeLength; i += 2) {
    sumOdd += parseInt(barcode[i], 10);
  }

  const sumOddTimesThree = sumOdd * 3;

  let sumEven = 0;
  for (let i = 1; i < barcodeLength; i += 2) {
    sumEven += parseInt(barcode[i], 10);
  }

  const totalSum = sumOddTimesThree + sumEven;
  const lastDigit = totalSum % 10;

  return lastDigit === 0 ? 0 : 10 - lastDigit;
};


  return (
  <>
    <br></br>
    <div class="container mt-5">
      <h4 class="text-center mb-4"><b>ลงทะเบียนใหม่</b></h4>
      <form autocomplete="off" class="shadow p-4 rounded bg-light">
                            
        <div class="mb-4">
          <label for="staticEmail" class="form-label"><b>เลขประจำตัวประชาชน</b></label>          
          <input type="text" class="form-control" id="cardid" name="cardid" onChange={(e) => handleEditChange(e)} />          
        </div>

        <div class="mb-4">
          <label for="staticName" class="form-label"><b>ชื่อ</b></label>          
          <input type="text" class="form-control" id="name" name="name" onChange={(e) => handleEditChange(e)}/>          
        </div>

        <div class="mb-4">
          <label for="staticLastName" class="form-label"><b>นามสกุล</b></label>          
          <input type="text" class="form-control" id="lastname" name="lastname" onChange={(e) => handleEditChange(e)} />          
        </div>

        <div class="mb-4">
          <label for="staticEmail" class="col-sm-1 col-form-label"><b>อีเมล</b></label>          
          <input type="email" class="form-control" id="email" name="email" onChange={(e) => handleEditChange(e)} />          
        </div>

        <div class="mb-4">
          <div class="col-sm-12">ถ้าคุณลืมรหัสผ่าน เราจะให้คุณบอกคำตอบสำหรับคำถามเพื่อความปลอดภัยที่คุณตั้งไว้เกี่ยวกับรหัสนั้น</div>
        </div>

        <div class="mb-4">
          <label for="staticquestionforsecurity" class="form-label"><b>คำถามความปลอดภัย</b></label>          
          <input type="text" class="form-control" id="questionforsecurity" name="questionforsecurity" onChange={(e) => handleEditChange(e)} />
          
        </div>

        <div class="mb-4">
          <label for="staticanswer" class="form-label"><b>คำตอบ</b></label>          
          <input type="text" class="form-control" id="answer" name="answer" onChange={(e) => handleEditChange(e)}/>          
        </div>


        <div class="mb-4">
        </div>

        <div class="mb-4">
          <label for="inputPassword" class="form-label"><b>รหัสผ่าน</b></label>          
          <input type="password" class="form-control" id="password" name="password" onChange={(e) => handleEditChange(e)}/>          
        </div>        


        <div class="mb-4">
          <label for="inputrePassword" class="form-label"><b>กรุณาใส่รหัสผ่านอีกครั้ง</b></label>
          <input type="password" class="form-control" id="repassword" name="repassword" onChange={(e) => handleEditChange(e)} />          
        </div>  

        <div class="mb-4">                    
            <button className='btn btn-primary w-100' onClick={btn_update}>ลงทะเบียน</button>                      
        </div>

    
      
      </form>
    </div>
   

  </>
  )
}

export default FrmNewRegister_th